import client from 'client/ApiClient';

function getPostData(token) {
  let url = `culture/posts/view_public?token=${token}`;
  return client(url, {});
}

export { getPostData };
